import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/Home.vue"),
  },
  {
    path: "/game",
    name: "game",
    component: () => import("@/views/Game.vue"),
  },
  {
    path: "/role-select",
    name: "role-select",
    component: () => import("@/views/RoleSelect.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
